import DiscardSeatOnTravellerChangeModule from './discard-seat-on-traveller-change/discard-seat-on-traveller-change-module';
import ClubCardService from './club-card-service';

const MODULE_NAME = 'App.Traveller';
const module = angular
    .module(MODULE_NAME, [
        DiscardSeatOnTravellerChangeModule,
    ])
    .service('clubCardService', ClubCardService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/traveller/traveller-module.js